import { getUrlData } from "@/helpers/appUrl.js";
const { appType } = getUrlData();
export const appInfo = {
  type: appType,
  name: "CODEMS",
  motto: "CODEMS",
  vision: "CODEMS",
  address: "CODEMS",
  email: "thecodeunit@gmail.com",
  phone: "CODEMS",
};
